let homeCollectionListApp = () => { };

homeCollectionListApp.openTab = (e) => {
    const currentTarget = e.currentTarget;

    if (currentTarget.classList.contains("tab_active")) {
        return;
    }
    let tabContent;

    const tablinkActive = document.querySelector(".tab_active");
    if (tablinkActive) {
        tablinkActive.classList.remove("tab_active");
        tabContent = document.querySelector("#" + tablinkActive.dataset.target);
      console.log(tablinkActive.dataset.target);
        if (tabContent) {
            tabContent.style.display = "none";
        }
    }

    currentTarget.classList.add("tab_active");

    tabContent = document.querySelector("#" + currentTarget.dataset.target);
    if (tabContent) {
        tabContent.style.display = "block";
    }
}

homeCollectionListApp.showCollectionProducts = (e) =>{
  let ancestor;
  if(e.target.classList.contains("mobiconic_collection_wrapper")){
    ancestor = e.target;
  } else {
    ancestor = e.target.closest(".mobiconic_collection_wrapper");
  }

  const active = document.querySelector(".product_list.active");

  if(ancestor === null){
    if(active !== null){
      active.classList.remove("active");
    }
  } else {
    const productListWrapper = ancestor.querySelector(".product_list");
    
    if(active !== null && active !== productListWrapper){
      active.classList.remove("active");
    }

    if(productListWrapper === null){
      return;
    }
  
    productListWrapper.classList.toggle("active");
  }
}

homeCollectionListApp.showPopularOrList = (e) => {
  const t = e.currentTarget;
  const ancestor = t.closest(".mobiconic_collections_list_wrapper");
  if(ancestor === null){
    return;
  }

  ancestor.style.display = "none";
  const target = document.querySelector(`${t.dataset.target}`);
  target.style.display = "initial";

  homeCollectionListApp.winScrollTo(homeCollectionListApp.collectionsTabsOffsetTop);
}

homeCollectionListApp.winScrollTo = (n) =>{
  let scrollY = window.scrollY;
  let id = setInterval(() => {
    window.scrollTo(0, (scrollY -= 10));
    if(scrollY <= n){
      clearInterval(id);
    }
  }, 1);
}

homeCollectionListApp.init = () => {
  homeCollectionListApp.collectionsTabs = document.querySelector(".mobiconic_collections_tab");
  homeCollectionListApp.collectionsTabsOffsetTop = homeCollectionListApp.collectionsTabs.offsetTop;

  const collectionsTabs = document.querySelector(".mobiconic_collections_tab");
  const tablinks = document.querySelectorAll(".collections_tab_wrapper .tablinks");
  const collectionItems = document.querySelectorAll(".mobiconic_collection_wrapper .collection_item");

  for (const tablink of tablinks) {
      tablink.addEventListener("click", homeCollectionListApp.openTab);
  }

  const btnCollectionLists = document.querySelectorAll(".btn_collection_list");
  for(const btn of btnCollectionLists) {
    btn.addEventListener("click", homeCollectionListApp.showPopularOrList);
  }

  //for(const collectionItem of collectionItems){
  //  collectionItem.addEventListener("click", homeCollectionListApp.showCollectionProducts);
  //}

  document.body.addEventListener("click", homeCollectionListApp.showCollectionProducts)

  if(typeof tablinks[0] !== "undefined"){
    tablinks[0].click();
  }
};

window.addEventListener("load", homeCollectionListApp.init);